import type { TMaritalStatus, TPledgeEstateOwnerRelationship } from 'constants/dictionaries';

import { mapLocalDictionary } from 'shared/lib/mapDictionaries';

import type { TPledgeEstateFormIncomingDictionaries } from '../types';

export const mapDictionary = (payload: Partial<TPledgeEstateFormIncomingDictionaries>) => {
  const { maritalStatuses, otherOwnerRelationship } = payload ?? {};

  return {
    maritalStatuses: mapLocalDictionary<TMaritalStatus>(maritalStatuses),
    otherOwnerRelationship: mapLocalDictionary<TPledgeEstateOwnerRelationship>(otherOwnerRelationship),
  };
};
